import { render, staticRenderFns } from "./MultiSectionItem.vue?vue&type=template&id=6a8b39f3&"
import script from "./MultiSectionItem.vue?vue&type=script&lang=js&"
export * from "./MultiSectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports